<template lang="html">
    <entity-page v-bind:loading="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
        </template>
        <div slot="default">
            <z-input name="logDescription" id="logDescription" label="Текст события"  v-model="log.description" disabled></z-input>
            <z-input name="logEntity" id="logEntity"  label="Наличие сущности" v-bind:value="(log.entity) ? 'Существует' : 'Удалена'" disabled></z-input>
            <z-input name="createdAt" id="createdAt"  label="Дата события" v-model="log.created_at" disabled></z-input>
            <z-input name="logType"   id="logType"    label="Тип события"  v-bind:value="(log.log_type === 'user') ? 'Пользовательское' : 'Системное'" disabled></z-input>
            <z-input name="logAction" id="logAction"  label="Код события"  v-model="log.log_action" disabled></z-input>
            <z-input name="userLogin" id="userLogin"  label="Пользователь" v-if="log.user" v-model="log.user.login" disabled></z-input>
            <z-input name="logModule" id="logModule"  label="Модуль" v-model="log.module.code" disabled></z-input>
        </div>
    </entity-page>
</template>
<script>
    import ZInput      from '@/components/ZInput';
    import ZIconButton from '@/components/ZIconButton';
    import EntityPage  from '@/components/EntityPage.vue';
    export default {
        components: { ZInput, ZIconButton, EntityPage },
        data() {
            return {
                sending: false,
                log: {
                    user: {
                        id: 0,
                        name: ''
                    },
                    module: {
                        id: 0,
                        code:'',
                        description: ''
                    }
                }
            }
        },
        watch: {
            '$route.params.log_id'() {
                this.init();
            },
        },
        created() {
            this.init();
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-log-card'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            }
        },
        methods: {
            /**
             * Инициализация компонента
             */
            init() {
                this.getLog();
                this.$store.commit('openRightPanel');
            },
            /**
             * Получение истории
             */
            getLog() {
                this.$store.commit('showProgressBar', 'load-log-card');
                this.$store.dispatch('logs/getLog', {id: this.$route.params.log_id}).then(r => {
                    if (!r) return;
                    this.log = Object.assign({}, r);
                    return this.log;
                }).finally(() => this.$store.commit('hideProgressBar', 'load-log-card'));
            },
            /**
             * Возвращает пользователя на предыдущую страницу
             */
            back() {
                this.$router.push({name: 'Logs', query: this.$route.query});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Log.vue?521c7691